<template>
  <section v-loading.fullscreen.lock="loading">
    <div class="term1">
      <div class="term1-top">
        <el-input v-model="input" placeholder="关键词搜索"></el-input>
        <span>日期:</span>
        <el-date-picker
          v-model="value1"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <span>查询</span>
      </div>
      <div class="term1-content">
        <el-table
          :header-cell-style="{ background: '#fafafa', 'text-align': 'center' }"
          :cell-style="{ 'text-align': 'center' }"
          :data="statisticsInfo.obj.tableData"
          stripe
          border
          style="width: 100%"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column prop="dm" label="标题" width="100">
          </el-table-column>
          <el-table-column prop="zbmc" label="内容"> </el-table-column>
          <el-table-column prop="dw" label="发布时间" width="100">
          </el-table-column>
          <el-table-column prop="sz" label="发布人"> </el-table-column>
          <el-table-column prop="qzlj" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="handleDetails">{{
                scope.row.cz1
              }}</el-button>
              <span v-if="scope.row.cz1" class="pad-row4">|</span>
              <el-button type="text" @click="handleDownload">{{
                scope.row.cz2
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="公告详情" :visible.sync="dialogVisible">
          <div class="details-title details-mb">2021河南报表指标解释文件</div>
          <div class="details-mb details-date">
            <span>发布人:管理员</span>
            <span>时间2022-03-24</span>
          </div>
          <div class="details-body details-mb"></div>
          <div>
            <span class="details-fj">附件:&nbsp;&nbsp;</span>
            <span class="details-download">2021河南报表指标解释文件</span>
          </div>
        </el-dialog>
      </div>
    </div>
  </section>
</template>
<script>
import mock from "@/utils/mock";
export default {
  name: "comTerm1",
  components: {},
  props: {},
  computed: {},
  watch: {},
  data() {
    return {
      loading: false,
      name: "",
      phone: "",
      statisticsInfo: mock.statistics.statistics.viewInfo,
      statisticsInit: mock.statistics.statistics.init,
      dm: "",
      content: "查看指标解释查看指标解释",
      input: "",
      value1: "",
      dialogVisible: false,
    };
  },
  mounted() {},
  methods: {
    handleDetails() {
      this.dialogVisible = true;
    },
    handleDownload() {
      this.$confirm("您确定要下载附件吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "下载成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消下载",
          });
        });
    },
    handlePre() {
      this.$emit("pre");
    },
    handleNext() {
      this.$emit("next");
    },
    handleOpen() {
      this.$alert(this.content, "查看指标解释", {
        confirmButtonText: "关闭",
        callback: (action) => {},
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.term1 {
  min-height: 720px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  &-top {
    display: inline-block;
    display: flex;
    padding-bottom: 25px;
    border-bottom: 1px solid #d7d7d7;
    &-info {
      display: inline-block;
      .el-input {
        width: 62%;
      }
    }
    > span {
      padding: 0px 15px;
      line-height: 40px;
      &:nth-child(4) {
        border: 1px solid #2f82ff;
        background-color: #2f82ff;
        color: #fff;
        border-radius: 5px;
        margin-left: 20px;
        height: 30px;
        line-height: 30px;
        margin-top: 5px;
        cursor: pointer;
      }
    }
  }
  &-content {
    margin-top: 25px;
    .icon {
      cursor: pointer;
      position: absolute;
      right: 8px;
    }
    .el-button {
      color: #2f82ff;
    }
    
  }
}
.term1-top-info /deep/ .el-input__inner {
  height: 34px;
}
.term1-top /deep/ .el-input {
  width: 200px;
  margin-right: 20px;
}
.term1-top /deep/ .el-range-input {
  width: 29%;
}
.term1-top /deep/ .el-range-separator {
  width: 7%;
}
.term1-top /deep/ .el-range-editor {
  width: 270px;
  justify-content: space-between;
}
.term1-content /deep/ .el-dialog__header{
  background-color: #f2f2f2;
}
.term1-content /deep/ .el-dialog{
  width: 500px;
  margin-top: 265px !important;
  .details-title{
    text-align: center;
    color: #444;
    font-size: 16px;
    
  }
  .details-mb{
    margin-bottom: 20px !important;
  }
  .details-date{
    text-align: center;
    > span{
      margin-right: 20px;
      font-size: 12px;
      color: #666;
    }
  }
  .details-body{
    border: 1px solid #444;
    min-height: 200px;
  }
  .el-dialog__body{
    padding-top: 20px !important;
  }
  .details-fj{
    font-size: 12px;
    color: #666;
  }
  .details-download{
    font-size: 12px;
    color: #2f82ff;
    cursor: pointer;
  }
}
</style>
